._1yexdnj0 {
  display: grid;
  grid-auto-rows: min-content;
  max-width: 100%;
  width: 100%;
}